import React from 'react';
import './App.css';
import Project from './Project';

function ProjectList({
  projects = [],
  projectsComingSoon = [],
  projectsClosed = [],
}) {
  return (
    <main>
      <div className="pp-projects-page mt-5 pt-3">
        <div className="pp-investment pp-open">
          <div className="container text-center">
            <div className="row d-flex">
              <div className="col-lg-12 text-center">
                <div className="section-text">
                  <h2 className="section-title">Projects Open Now</h2>
                  <p className="section-description" />
                </div>
              </div>
            </div>
            <div className="investment-section-items">
              <div className="row d-flex ">
                {projects.map(project => (
                  <Project project={project} />
                ))}
                {projects.length === 0 && (
                  <div>
                    <span>No projects currently open</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="pp-investment pt-0" style={{ backgroundImage: 'none' }}>
          <div className="container text-center">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-12 text-center">
                <div className="section-text">
                  <h2 className="section-title">Projects Coming soon</h2>
                  <p className="section-description" />
                </div>
              </div>
            </div>
            <div className="investment-section-items">
              <div className="row d-flex">
                {projectsComingSoon.map(project => (
                  <Project project={project} />
                ))}
                {projectsComingSoon.length === 0 && (
                  <div>
                    <span>No projects coming soon</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="pp-investment pt-0" style={{ backgroundImage: 'none' }}>
          <div className="container text-center">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-12 text-center">
                <div className="section-text">
                  <h2 className="section-title">Closed Projects</h2>
                  <p className="section-description" />
                </div>
              </div>
            </div>
            <div className="investment-section-items">
              <div className="row d-flex">
                {projectsClosed.map(project => (
                  <Project project={project} />
                ))}
                {projectsClosed.length === 0 && (
                  <div>
                    <span>No projects closed</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="pp-investment pp-close">
          <div className="container text-center">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-12 text-center">
                <div className="section-text">
                  <h2 className="section-title">Projects Closed</h2>
                  <p className="section-description" />
                </div>
              </div>
            </div>
            <div
              className="table-input-search d-flex align-items-center"
              style={{
                border: '1px solid rgba(206, 212, 218, 0.2)',
                borderRadius: '16px',
              }}>
              <span className="mdi mdi-magnify ms-3 me-1" />
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Project Name"
                defaultValue
                style={{
                  backgroundColor: 'transparent',
                  border: '0px',
                  boxShadow: 'none',
                  outline: '0px',
                  color: 'rgb(153, 153, 153)',
                }}
              />
            </div>
            <div className="investment-section-items">
              <div className="row d-flex ">
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0x817F6bEA39b82A152B541566b7Fc8F9635350BCA">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/tQy85XW/WWY.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0x817F6bEA39b82A152B541566b7Fc8F9635350BCA">
                              <div>WeWay</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a href="http://weway.io/" target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/WeWay_io"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a href="https://t.me/WeWay_io" target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0x817F6bEA39b82A152B541566b7Fc8F9635350BCA">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          Entertainment ecosystem focusing on creating tools for
                          fans to get closer to their favorite influencers and
                          express themselves.
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0x817F6bEA39b82A152B541566b7Fc8F9635350BCA">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 200 WWY</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>300000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  3640
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.002%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.00%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>300006.4960/300000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0x40a9ae18D12f9f31C324Ac187823873897530e36">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/crcGy6L/WOD.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0x40a9ae18D12f9f31C324Ac187823873897530e36">
                              <div>World of Defish</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a
                              href="https://worldofdefish.com/"
                              target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/worldofdefish"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@worldofdefish"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://t.me/worldofdefish"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0x40a9ae18D12f9f31C324Ac187823873897530e36">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          A Metafish Universe where every Item, Zone &amp;
                          Equipment is a profit-generating NFT{' '}
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0x40a9ae18D12f9f31C324Ac187823873897530e36">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 38.4615 WOD</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>150000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  3255
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.006%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.01%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>150008.5481/150000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0x56347C218290bD62ac6D46529f70Ac4E5C32b207">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/crcGy6L/WOD.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0x56347C218290bD62ac6D46529f70Ac4E5C32b207">
                              <div>World of Defish (Blue Diamond Private)</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a
                              href="https://worldofdefish.com/"
                              target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/worldofdefish"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@worldofdefish"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://t.me/worldofdefish"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0x56347C218290bD62ac6D46529f70Ac4E5C32b207">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          A Metafish Universe where every Item, Zone &amp;
                          Equipment is a profit-generating NFT{' '}
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0x56347C218290bD62ac6D46529f70Ac4E5C32b207">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 55.5555 WOD</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>25000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">279</b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.053%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.05%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>25013.1333/25000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0xe3af122CFfCc38c62bDD7C7D1aBE012BB6214276">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/GtGczqm/KATA.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0xe3af122CFfCc38c62bDD7C7D1aBE012BB6214276">
                              <div>Katana Inu</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a href="https://katanainu.com/" target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://www.twitter.com/katanainu"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@katanainu"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://www.t.me/katanainu"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0xe3af122CFfCc38c62bDD7C7D1aBE012BB6214276">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-p1">
                        <div className="item-short-desc">
                          Battle Royale Game with NFT Skins
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0xe3af122CFfCc38c62bDD7C7D1aBE012BB6214276">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 1000 KATA</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>500000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  3845
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.008%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.01%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>500037.5848/500000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0x3d1E86ec1fe7D2fDa39b73A88dfBa1942CF15817">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/GtGczqm/KATA.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0x3d1E86ec1fe7D2fDa39b73A88dfBa1942CF15817">
                              <div>Katana Inu (Blue Diamond Private)</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a href="https://katanainu.com/" target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://www.twitter.com/katanainu"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@katanainu"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://www.t.me/katanainu"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0x3d1E86ec1fe7D2fDa39b73A88dfBa1942CF15817">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          Battle Royale Game with NFT Skins
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0x3d1E86ec1fe7D2fDa39b73A88dfBa1942CF15817">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 1333.3333 KATA</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>200000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">291</b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.012%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.01%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>200023.5940/200000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0xea0CD3E448c2ee501c82a3bf233b345820C0F87B">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/ZhpJNFq/ORO.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0xea0CD3E448c2ee501c82a3bf233b345820C0F87B">
                              <div>Operon Origins</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a
                              href="https://operonorigins.com/"
                              target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/OperonOrigins"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@operonorigins"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://t.me/operonorigins"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0xea0CD3E448c2ee501c82a3bf233b345820C0F87B">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          Fight for future supremacy among elite, genetically
                          enhanced superhumans in a unique, card-based NFT
                          combat game
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0xea0CD3E448c2ee501c82a3bf233b345820C0F87B">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 10 ORO</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>200000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  3788
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.004%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.00%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>200007.1956/200000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0xa359fF823bF7A18B9c3Eb8444Fb27F699926a066">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/ZhpJNFq/ORO.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0xa359fF823bF7A18B9c3Eb8444Fb27F699926a066">
                              <div>Operon Origins (Blue Diamond Private)</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a
                              href="https://operonorigins.com/"
                              target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/OperonOrigins"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@operonorigins"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://t.me/operonorigins"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0xa359fF823bF7A18B9c3Eb8444Fb27F699926a066">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          Fight for future supremacy among elite, genetically
                          enhanced superhumans in a unique, card-based NFT
                          combat game
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0xa359fF823bF7A18B9c3Eb8444Fb27F699926a066">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 13.3333 ORO</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>30000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">299</b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.044%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.04%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>30013.1148/30000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0x542713A2CAE193fFA79615bCEbD0a9728d3E1429">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/yd3Gr0h/TAU.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0x542713A2CAE193fFA79615bCEbD0a9728d3E1429">
                              <div>Atlantis Metaverse</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a
                              href="https://www.theatlantis.io/"
                              target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/atlantis_TW"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a href="https://t.me/atlantisANN" target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0x542713A2CAE193fFA79615bCEbD0a9728d3E1429">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          Welcome to Atlantis Metaverse, a Metaverse Gaming
                          project based on Greek Mythology, a fantasy universe
                          along with turn-based RPG mechanism.
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0x542713A2CAE193fFA79615bCEbD0a9728d3E1429">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 8.3333 TAU</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>125000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  3664
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.009%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.01%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>125011.8521/125000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0xd445d5b9d9583cc1C8e5D8964ABfB389E42BdA02">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/8KfzS09/METAVPAD.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0xd445d5b9d9583cc1C8e5D8964ABfB389E42BdA02">
                              <div>MetaVPad</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a href="https://metavpad.com/" target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/MetaVPad"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@metavpad"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a href="https://t.me/metavpadann" target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0xd445d5b9d9583cc1C8e5D8964ABfB389E42BdA02">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          METAVPAD - Building the Metaverse, One Block at a time
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0xd445d5b9d9583cc1C8e5D8964ABfB389E42BdA02">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 1000 METAV</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>120000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  4225
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.001%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.00%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>120000.9970/120000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0xA19fdD15c9C457BD58E14854dc95FD45324F88b2">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/8KfzS09/METAVPAD.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0xA19fdD15c9C457BD58E14854dc95FD45324F88b2">
                              <div>MetaVPad (Blue Diamond Private)</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a href="https://metavpad.com/" target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/MetaVPad"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@metavpad"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a href="https://t.me/metavpadann" target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0xA19fdD15c9C457BD58E14854dc95FD45324F88b2">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          METAVPAD - Building the Metaverse, One Block at a time
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0xA19fdD15c9C457BD58E14854dc95FD45324F88b2">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 1010.101 METAV</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>10000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">321</b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.091%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.09%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>10009.0779/10000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0x2b42B7B53387198d3658964eE22751D47864948B">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/JrFx04p/LACE.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0x2b42B7B53387198d3658964eE22751D47864948B">
                              <div>Lovelace</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a
                              href="https://www.lovelace.world/"
                              target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/LovelaceWorld"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://lovelaceworld.medium.com/"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://t.me/lovelaceofficial"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0x2b42B7B53387198d3658964eE22751D47864948B">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          LOVELACE is the first Metaverse as a Service platform
                          allowing creators to easily develop digital products
                          with gamified rewards.
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0x2b42B7B53387198d3658964eE22751D47864948B">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 22.2222 LACE</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>150000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  3367
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.001%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.00%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>150002.0924/150000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 text-center">
                  <div className="single-item">
                    <div className="pp-card-body">
                      <div className="pp-card-top">
                        <a href="/project/0xc12C06026607eC221018180A1ac14351b1D02F78">
                          <div className="icon-box">
                            <span>
                              <img
                                src="https://i.ibb.co/Yfz9pSW/EYE.jpg"
                                alt="#"
                              />
                            </span>
                          </div>
                        </a>
                        <div className="title-box">
                          <h3 className="d-flex align-items-center">
                            <a href="/project/0xc12C06026607eC221018180A1ac14351b1D02F78">
                              <div>MeDIA eYe</div>
                            </a>
                          </h3>
                          <div className="item-social">
                            <a href="https://mediaeyenft.com/" target="_blank">
                              <i className="fas fa-globe" />
                            </a>
                            <a
                              href="https://twitter.com/MeDIAeYeNFT"
                              target="_blank">
                              <i className="fab fa-twitter" />
                            </a>
                            <a
                              href="https://medium.com/@MeDIAeYeNFT"
                              target="_blank">
                              <i className="fab fa-medium-m" />
                            </a>
                            <a
                              href="https://t.me/MeDIAeYeNFTofficial"
                              target="_blank">
                              <i className="fab fa-telegram" />
                            </a>
                          </div>
                          <a
                            className="items-morex"
                            href="/project/0xc12C06026607eC221018180A1ac14351b1D02F78">
                            <span className="pp-status-closed">
                              <i className="mdi mdi-circle" /> Closed
                            </span>
                            <div>
                              <span className>BUSD</span>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="item-desc mb-1">
                        <div className="item-short-desc">
                          MeDIA eYe NFT Portal is an innovative and unique
                          platform, one that will revolutionize the NFT creator
                          market.
                        </div>
                        <div className="item-learn-more" />
                      </div>
                      <a href="/project/0xc12C06026607eC221018180A1ac14351b1D02F78">
                        <div className="part-prize">
                          <div className="pp-card-info mb-3">
                            <div className="pp-card-col">
                              Swap rate
                              <br />
                              <b className="nowrap">1 BUSD = 66.6666 eYe</b>
                            </div>
                            <div className="pp-card-col text-center ps-28">
                              Cap
                              <br />
                              <b>150000 </b>
                            </div>
                            <div className="pp-card-col text-end">
                              Access
                              <br />
                              <b>Private</b>
                            </div>
                          </div>
                          <div className="pp-card-progress-wrap">
                            <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                              <div className="pp-card-col">Progress</div>
                              <div className="pp-card-col text-end">
                                Participants{' '}
                                <b className="text-participants font-12">
                                  3172
                                </b>
                              </div>
                            </div>
                            <div className="pp-card-progress">
                              <div
                                title={9}
                                className="pp-card-progress-percent"
                                style={{ width: '100.011%' }}
                              />
                              <div className="pp-card-progress-label">
                                <span>
                                  <b>100.01%</b>
                                </span>
                                <span className="text-allocation">
                                  <b className>150016.8589/150000</b>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <ul className="pagination">
                  <li className="page-item disabled">
                    <span className="page-link" disabled>
                      <span aria-hidden="true">‹</span>
                      <span className="sr-only">Previous</span>
                    </span>
                  </li>
                  <li className="page-item active">
                    <span className="page-link">
                      1<span className="sr-only">(current)</span>
                    </span>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      4
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      5
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      6
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      7
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      8
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      9
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      10
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" role="button" href="#">
                      <span aria-hidden="true">›</span>
                      <span className="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </main>
  );
}

export default ProjectList;
